var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 984,
    height: 638,
    viewBox: "0 0 984 638",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M195.856 498.659H280.653V424.124H333.044V350.669H280.113V116.262H171.551L16 347.969V424.124H195.856V498.659ZM104.038 350.669L194.776 209.161H196.396V350.669H104.038Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.659 508.921C607.68 508.921 648.729 414.942 648.729 306.38C648.729 198.359 607.68 106 499.659 106C391.097 106 349.509 198.359 349.509 306.38C349.509 414.942 391.097 508.921 499.659 508.921ZM499.659 431.145C451.589 431.145 442.407 355.53 442.407 306.38C442.407 258.311 451.589 182.695 499.659 182.695C547.188 182.695 555.83 258.311 555.83 306.38C555.83 355.53 547.188 431.145 499.659 431.145Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M840.189 498.659H924.986V424.124H977.376V350.669H924.446V116.262H815.884L660.333 347.969V424.124H840.189V498.659ZM748.37 350.669L839.108 209.161H840.729V350.669H748.37Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M791.5 137.5L662.5 331.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 816.301,
    y1: 230.382,
    x2: 774.382,
    y2: 295.699,
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915 132L915 338",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 915,
    y1: 441,
    x2: 915,
    y2: 486,
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831 440L831 499L915.5 499",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831 209L831 350L739.5 350L763 313.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832 424H800",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M744.5 424H699",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.5 424H652",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M914.5 116L832 116",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M652 353L652 423.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915.5 424L968 424L968 351H914",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 175C253.5 291.5 340 302.255 401.5 291.5L398 300C219 326 364 197.5 431 168L433 175Z",
    fill: "white",
    stroke: "#007288",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 483C753.951 496.589 881.69 544.479 958.5 627",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.406 469.66C781.438 469.66 792.813 458.286 792.813 444.254C792.813 430.222 781.438 418.848 767.406 418.848C753.375 418.848 742 430.222 742 444.254C742 458.286 753.375 469.66 767.406 469.66Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.817 48.8428C290.343 48.8428 295.634 43.5522 295.634 37.0259C295.634 30.4996 290.343 25.209 283.817 25.209C277.291 25.209 272 30.4996 272 37.0259C272 43.5522 277.291 48.8428 283.817 48.8428Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.853 518.171C113.463 518.171 115.58 516.055 115.58 513.445C115.58 510.834 113.463 508.718 110.853 508.718C108.242 508.718 106.126 510.834 106.126 513.445C106.126 516.055 108.242 518.171 110.853 518.171Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.301 53.3714C297.61 53.3714 302.724 48.2572 302.724 41.9484C302.724 35.6397 297.61 30.5254 291.301 30.5254C284.992 30.5254 279.878 35.6397 279.878 41.9484C279.878 48.2572 284.992 53.3714 291.301 53.3714Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 629C100.523 561.841 231.583 508.718 369.447 488.629",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.5 137.5L18.5 331.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.301,
    y1: 230.382,
    x2: 130.382,
    y2: 295.699,
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271 132L271 338",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 271,
    y1: 441,
    x2: 271,
    y2: 486,
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 440L187 499L271.5 499",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187 209L187 350L95.5 350L119 313.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188 424H7",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.5 116L188 116",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.99997 354L7 424",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.5 424L324 424L324 351H270",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5976 449.043L102.581 456.724L88.5976 464.405L80.7197 478.585L73.0387 464.405L58.8584 456.724L73.0387 449.043L80.7197 434.862L88.5976 449.043Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M927.009 66.3708L934.493 70.7036L927.009 74.8396L922.676 82.5205L918.54 74.8396L910.859 70.7036L918.54 66.3708L922.676 58.8867L927.009 66.3708Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M777.058 459.813C791.089 459.813 802.464 448.438 802.464 434.406C802.464 420.375 791.089 409 777.058 409C763.026 409 751.651 420.375 751.651 434.406C751.651 448.438 763.026 459.813 777.058 459.813Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 628C60 628 128 570 187.072 555.591",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.654 162.24C168.868 162.24 190.119 140.989 190.119 114.775C190.119 88.5612 168.868 67.3105 142.654 67.3105C116.44 67.3105 95.1895 88.5612 95.1895 114.775C95.1895 140.989 116.44 162.24 142.654 162.24Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.636 165C185.787 165 209.418 141.369 209.418 112.218C209.418 83.067 185.787 59.4355 156.636 59.4355C127.485 59.4355 103.854 83.067 103.854 112.218C103.854 141.369 127.485 165 156.636 165Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.708 71.8423C211.781 60.4192 226.749 54.7077 228.916 57.8589C232.461 63.1765 201.343 89.7646 159.393 117.534C117.443 145.304 80.8105 163.423 77.2654 158.303C75.099 154.955 86.325 143.335 106.217 127.776",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.404 78.7355C216.902 68.2972 228.522 64.1613 230.689 67.3125C234.234 72.6301 203.116 99.2181 161.166 126.988C119.216 154.758 82.5834 172.877 79.0384 167.756C76.675 164.211 87.7041 152.788 109.368 136.048",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322 514.123C322 514.123 352.723 517.172 351.032 537.117C349.871 550.767 333.329 564.417 333.329 564.417C333.329 564.417 364.682 552.104 368.734 534.363C368.734 534.363 371.861 512.156 322 514.123Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195 593.43C195 593.43 215.122 596.026 213.489 609.637C211.856 623.248 195 638.314 195 638.314C195 638.314 227.238 624.546 231.171 606.844C231.171 606.883 234.319 583.575 195 593.43Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M914.019 606.353C907.367 617.657 883.703 613.981 861.139 598.138C838.575 582.295 825.754 560.303 832.406 549",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M193.862 640.161C218.881 629.323 235.232 611.463 230.383 600.269C225.534 589.075 201.321 588.786 176.301 599.625C151.282 610.463 134.931 628.323 139.78 639.517C144.629 650.711 168.842 651 193.862 640.161Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M315.702 569.259C348.045 561.822 371.547 543.975 368.195 529.397C364.843 514.818 335.906 509.029 303.563 516.466C271.219 523.903 247.717 541.75 251.07 556.329C254.422 570.907 283.359 576.696 315.702 569.259Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.755 520.73C735.755 520.73 779.755 531.371 775.093 550.942C770.884 568.507 743.465 567.071 743.465 567.071C743.465 567.071 792.127 574.211 792.304 553.303C792.382 545.868 784.613 530.88 735.755 520.73Z",
    fill: "#DBFCFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.34,
    d: "M792.439 555.514C795.037 543.595 772.873 528.642 742.934 522.115C712.994 515.588 686.617 519.958 684.018 531.877C681.42 543.795 703.584 558.748 733.524 565.276C763.463 571.803 789.841 567.432 792.439 555.514Z",
    stroke: "#007288",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.869 407.287C728.486 253.397 583.371 270.76 509.938 283.448C509.938 283.448 506.32 285.153 504.401 281.083C502.483 277.012 505.888 274.855 505.888 274.855C708.989 235.723 727.326 336.542 712.003 404.885C696.679 473.227 702 477 737 507.501L721.5 503.5C677 481 692.754 445.552 699.869 407.287Z",
    fill: "white",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.191 294.544C469.766 294.743 449.043 298.052 442.247 299.325L443.915 290.677L461.081 287.683L478.587 284.04C477.466 287.458 474.616 294.345 472.191 294.544Z",
    fill: "white",
    stroke: "#007288",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.055 67.9023L471.446 71.0655L511.03 80.971C552.792 101.717 571.051 130.557 575.102 141.777C575.984 143.696 576.444 145.154 576.542 146.234C589.225 186.809 586.858 216.298 580.948 222.37C573.352 228.986 562.453 225.392 557.954 222.768L545.036 159.901L530.559 148.695C539.633 192.713 542.824 222.473 537.186 236.885L537.106 237.089C534.868 242.807 524.405 269.544 520 288C518.332 302.052 530.443 312.834 526.056 311.78C518.44 309.95 484.775 321.826 478 319.5C471.642 317.317 469.835 286.321 469.835 286.321C466.98 274.4 453.974 286.081 446 302L486 351C479.561 365.072 478.748 376.977 450.5 378.5C391.886 313.338 383 317.5 414.706 262.005C423.183 239.32 435.971 222.685 440.539 208.924L438.39 176.219L430.352 175.585L425.875 166.087L426.025 149.987C426.025 149.987 423.483 154.498 420.5 157.5C390.002 188.184 342.5 200 332.5 181.5C329.364 175.697 376.282 162.5 389.5 139C398.5 122.999 435.163 73.759 446.055 67.9023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.569 81.4583C528.305 79.666 555.091 100.758 574.385 141.691C585.777 164.054 588.155 210.157 580.968 223.467C580.968 223.467 576.023 225.494 570.887 225.988C564.058 226.645 558.633 224.072 558.633 224.072L545.242 159.995C531.575 151.661 514.115 134.788 509.262 124.126",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.523 209.467C440.519 191.809 441.545 195.025 438.426 176.863",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.531 165.734C446.825 166.956 474.628 166.811 494.112 166.035L500.003 177.324C468.7 178.743 448.464 176.507 430.517 175.466L425.531 165.734ZM425.531 165.734C425.531 165.734 426.735 147.514 428.678 120.536C436.052 116.688 440.4 114.419 440.4 114.419C458.971 113.881 491.02 114.615 505.259 114.368",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.001 197.5C356.001 192.501 388.432 182.558 399.501 175C420.001 161.001 418.061 160.01 426.549 148.81",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.297 300.284L494.355 310.631L471.231 319.564L527.758 392.785L541.557 415.026L552.386 411.027L556 415.026L551.615 453.953C551.615 453.953 556.835 460.337 569.738 453.702C582.641 447.067 581.563 426.018 581.563 426.018L583.463 421.253L585.362 416.488L587.5 411.027L587.5 403.5L575.847 392.782L561.589 361.361L539.901 322.389L522.297 300.284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 480.682,
    cy: 48.7003,
    r: 42.0761,
    transform: "rotate(31.3758 480.682 48.7003)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.397 84.9797C434.118 70.997 429.494 38.9055 449.44 20.0425C465.357 2.59098 492.407 1.34695 509.859 17.2639C527.31 33.1808 528.554 60.2312 512.637 77.6827L506.528 83.9124",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.001 182C341.501 170 363.501 152.5 386.001 145C386.001 145 395.501 129.5 403.001 117.5C410.501 105.5 427.001 81.5002 446.001 79.9993",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.699 39.3422C479.668 23.1978 457.278 25.6008 444.584 33.3292C437.26 55.7129 448.771 72.7614 455.442 78.4877C470.35 89.2706 491.86 81.5817 500.752 76.3893L498.699 39.3422Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.815 413.525L564.667 420.906",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491 415C491.863 416.023 492.903 417.859 493.015 420.5C493.12 422.967 490 429.5 490 429.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.593 411.032L569.445 418.414",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.935 408.767L573.786 416.148",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.304 31.1268C452.317 21.8816 482.584 11.6377 506.977 41.4444",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.913 37.7811C449.926 28.5359 480.923 16.9239 505.316 46.7307",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.501 115C437.745 109.316 436.347 94.5295 447.88 77.4632",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.984 114.143C494.211 109.085 495.513 95.6969 506.481 83.8963",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.01 113.614C448.776 102.74 451.914 91.9487 455.5 84",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.481 114.802C506.048 109.533 509.667 91.3714 523.73 84.0336",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.795 121.15L497.496 121.732",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.93 121.506L505.254 114.369",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.666 166.268L497.496 121.732",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.087 177.311L505.689 114.141",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.216 151.066L478.732 151.411L480.115 138.536L495.911 137.751",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.395 137.901L443.88 137.555L442.496 150.431L426.7 151.215",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.22 143.084C511.721 146.167 529.191 154.486 532.559 156.706",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.351 156.243C512.156 159.688 530.751 167.206 534.691 169.721",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.754 411.292L555 415.5L551.87 453.845C555.03 458.71 570.307 456.391 574.373 450.222C581.385 439.583 582.142 426.686 585.5 416C591.144 400.957 583.838 399.167 575.301 392.082",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.31 251.461L558.567 224.857C562.1 225.839 569.583 227.142 578.401 224.644L594.441 246.652C600.733 254.86 599.127 256.623 597.135 257.31C594.671 258.161 590.155 250.296 588.189 247.76C586.702 245.842 586.134 247.702 586.555 248.921L590.913 261.476C592.452 265.4 588.674 267.048 587.235 264.591L580.955 251.535C579.688 248.853 578.237 250.201 578.657 251.419L582.553 267.661C582.845 271.737 578.248 272.117 577.463 268.494C576.283 263.052 574.368 257.148 573.761 253.974C573.07 250.357 570.865 250.557 571.356 253.616L571.389 270.879C570.784 274.587 565.852 273.769 565.731 270.362L564.73 250.444C564.74 244.014 562.271 243.648 561.35 245.026L555.788 253.129C552.875 256.962 550.66 253.614 551.31 251.461Z",
    fill: "white",
    stroke: "#007288",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.506 222.746L467.108 182.029",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.262 182.248L457.66 222.965C457.433 229.52 459.205 243.13 468.106 245.126",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.1 66.9502L535.405 72.4492L538.531 91.9807",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.072 339.081C495.302 339.174 514.334 333.114 528.157 308.026",
    stroke: "#007288",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.803 238.202C528.014 208.044 523.801 180.733 518.538 163.314L526.737 166.636L534.696 170.622L539.534 203.166C539.142 200.771 540.304 214.802 539.998 221.741C539.29 237.829 525.665 263.271 521 281.5C518.932 293.53 520.753 299.355 523.337 303.665C531.672 310.791 540.443 325.082 545.691 333.48C553.49 344.396 569.077 376.074 575.446 390.76C575.446 390.76 575.873 391.665 572.203 395.606C568.533 399.547 568.772 398.881 568.772 398.881C549.488 372.042 510.111 316.864 505.997 309.074C498.644 295.152 507.767 262.51 516.803 238.202Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.267 346.062L552.28 375.947",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.968 392.091C574.968 392.091 548 326.5 527 308C506 289.5 538.112 254.729 539.436 217.031C540.22 194.692 531.596 149.973 531.596 149.973",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.452 315.956C434.918 325.995 428.081 331.558 413.209 336.228",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.372 306.029C429.705 296.172 455.931 265.421 468.138 253.403L468.577 273.095L446.84 299.924C443.01 303.056 445.79 304.104 446.589 305.018C449.379 308.124 462.378 318.58 468.573 327.268C475.341 332.593 499.63 373.601 512.666 397C513.17 397.903 513.656 398.78 514.124 399.628L512.666 397C512.666 397 511.407 399.17 509.5 402C507.783 404.548 504.428 405.442 504.428 405.442L457.674 344.014C447.446 331.699 431.038 315.885 430.372 306.029Z",
    fill: "#91D6DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.522 209.468C440.522 209.468 424.113 243.624 417.763 255.59C405.244 279.179 398.971 294.036 397.034 300.738C394.628 309.058 397.79 316.888 403.659 324.7C419.838 346.234 474.225 406.203 486.5 417M468.551 274.213L445.309 302.304C443.927 304.061 472.166 318.57 515.896 402.8C519.029 405.93 523 408 524 413.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.5 417C486.5 417 506.954 407.495 513 398.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.41 238.558C467.304 254.788 468.329 303.061 477.07 321.604C485.384 339.243 519.533 382.475 541.993 414.508C548.028 413.017 565.05 405.058 574.968 392.091",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5 198C339.167 204.5 329.5 221.5 327 221.5C326.167 221.167 321.833 220.5 326.5 212.5C330.009 206.484 330 204 327 203C324.6 202.2 317.5 209.5 314 215L310 222C308.5 223.5 307.032 223.031 306 222C304.8 220.8 306.455 215.5 309 211.5C310.167 209.667 312.5 205.5 315 203",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310 199C309.5 199.5 298.5 213.5 299.5 219C299.5 221 303 223.5 306.5 216.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.499 182.499C308 188 294.061 203.41 294 209C293.983 210.5 296.013 212.5 299.255 208.275C301 206 303.5 201.499 309 200",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332 182L342 197.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317 187.5C310.167 189.833 292.499 195.5 297.999 200.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548 304C549 316.5 547.5 332.5 547.5 335M345 360.5C357.628 443.9 401.607 507.921 491.21 507.921C535.789 507.921 568.962 491.915 592.551 465.484M630.029 391.5C637.053 365.106 640.28 335.816 640.28 305.38C640.28 298.517 640.114 291.717 639.776 285M633.182 233C636.024 246.264 637.373 257.164 638.5 271.5M443.091 381.5C451.136 408.842 465.695 430.145 491.21 430.145C507.543 430.145 519.284 421.216 527.66 407.5",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.5 194.5C618.167 186.5 611 169 600.5 159",
    stroke: "#007288",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 984,
    height: 638,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.34bb78fe0aba396b687f14b89a8e0d4d.svg";
export { ForwardRef as ReactComponent };